import React from 'react';
import { MediaGrid } from './MediaGrid';
import { SectionDetailBackground } from './SectionDetailBackground';
import { SectionDetailHeader } from './SectionDetailHeader';
import { loadMediaSection } from '../../api/pac/load-media-section';
import { queryKeys } from '../../config/use-query';
import { useVideoConfig } from '../../config/VideoAppContext';
import { useAxios } from '../../hooks/use-axios';
import { usePaging } from '../../hooks/use-paging';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaSectionDetail = ({
  sectionDetail
}) => {
  const axios = useAxios();
  const {
    usePreview,
    previewDate
  } = useVideoConfig();
  const {
    data = [],
    canLoadMore,
    loadMore
  } = usePaging(queryKeys.MediaSection(sectionDetail.id), next => loadMediaSection(axios, sectionDetail.id, usePreview, previewDate, next), {
    initialData: {
      pages: [sectionDetail?.data],
      pageParams: []
    }
  });
  return /*#__PURE__*/_jsxs(SectionDetailBackground, {
    sectionDetail: sectionDetail,
    children: [/*#__PURE__*/_jsx(SectionDetailHeader, {
      sectionDetail: sectionDetail
    }), /*#__PURE__*/_jsx(MediaGrid, {
      medias: data,
      canLoadMore: canLoadMore,
      loadMore: loadMore,
      analyticsTitle: sectionDetail.representation.title,
      labelOrder: ['live', 'expiringSoon']
    })]
  });
};